import * as XState from 'xstate'
import * as Network from '@avcan/utils/dom/network'

export default XState.createMachine({
    id: 'network',
    initial: 'checking',
    states: {
        checking: {
            always: [
                {
                    target: 'online',
                    cond() {
                        return Network.getOnLine()
                    },
                },
                {
                    target: 'offline',
                },
            ],
        },
        online: {
            initial: 'unknown',
            invoke: {
                id: 'offline',
                src() {
                    return callback => {
                        const connection = Network.getConnection()
                        function goOffline() {
                            callback('OFFLINE')
                        }
                        function connectionChange(event) {
                            callback('CONNECTION_CHANGE')
                        }

                        window.addEventListener('offline', goOffline)
                        connection?.addEventListener('change', connectionChange)

                        return () => {
                            window.removeEventListener('offline', goOffline)
                            connection?.removeEventListener('change', connectionChange)
                        }
                    }
                },
            },
            on: {
                OFFLINE: 'offline',
                CONNECTION_CHANGE: 'online',
            },
            states: {
                slow: {
                    type: 'final',
                },
                medium: {
                    type: 'final',
                },
                fast: {
                    type: 'final',
                },
                unknown: {
                    always: [
                        {
                            target: 'slow',
                            cond() {
                                const effectiveType = navigator.connection?.effectiveType

                                return effectiveType === 'slow-2g' || effectiveType === '2g'
                            },
                        },
                        {
                            target: 'medium',
                            cond() {
                                return navigator.connection?.effectiveType === '3g'
                            },
                        },
                        {
                            target: 'fast',
                            cond() {
                                return navigator.connection?.effectiveType === '4g'
                            },
                        },
                    ],
                },
            },
        },
        offline: {
            invoke: {
                id: 'online',
                src() {
                    return callback => {
                        function listener() {
                            callback('ONLINE')
                        }

                        window.addEventListener('online', listener)

                        return () => {
                            window.removeEventListener('online', listener)
                        }
                    }
                },
            },
            on: {
                ONLINE: 'online',
            },
        },
    },
})
